import { useEffect } from 'react';

export function useFacebookSDK(appId, { version = 'v20.0', cookie = false, xfbml = false } = {}) {
    useEffect(() => {
        const initOptions = { appId, version, cookie, xfbml };
        if (document.getElementById('facebook-jssdk')) {
            if (window.FB) window.FB.init(initOptions);
            return;
        }
        window.fbAsyncInit = function () {
            window.FB.init(initOptions);
        };
        const s = document.createElement('script');
        s.id = 'facebook-jssdk';
        s.async = true;
        s.defer = true;
        s.crossOrigin = 'anonymous';
        s.src = 'https://connect.facebook.net/pt_BR/sdk.js';
        document.body.appendChild(s);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps -- SDK init runs once on mount intentionally
}
